import { getData } from '@/views/arki/services/arki-service';
export const getRequests = async () => {
    return await getData('/request/list', '2788fbd5-8cc2-4088-89df-daaf5ee561a4');
}

export const getProjects = async (requestId) => {
    return await getData('/request/projects', 'e862903b-12d7-4d4a-b3b5-98f94c2e3d58', { requestId});
}
